<template>
    <section  class="px-content py-20 relative will-change" :class="computedClass" :data-scroll-section="inner == 'false'">
        <div class="mb-12">
            <h2 class="text-heading mb-8" v-show="blockData.title">{{ blockData.title }}</h2>
            <p class="xl:max-w-[40vw]" v-show="blockData.text" v-html="blockData.text"></p>
        </div>

        <!-- card list -->
        <div class="grid  xl:grid-cols-4 xl:gap-6">
            <XyzTransitionGroup appear-visible class="mb-4" v-show="partners" v-for="(partner, index) in partners" :key="index" xyz="delay-1 fade duration-20">
                <div class="flex items-center justify-center bg-white rounded shadow-picto mb-6 p-10 h-40 2xl:h-56" :key="'imgdiv'+index">
                    <img class="" v-show="partner.data.fields.image" :src="partner.data.fields.image.url" :alt="partner.data.fields.image.alt">
                </div>

                <h4 class="text-xl tracking-[1px] mb-3" v-show="partner.title.rendered" :key="partner.title.rendered+index" v-html="partner.title.rendered"></h4>
                <a  class="text-xs tracking-little text-navy-blue-02 font-bold uppercase mt-auto" v-show="partner.data.fields.cta" href="javascript:void(0);" @click="openBlank(partner.data.fields.cta.url)" :key="partner.data.fields.cta + index">{{__('VISIT WEBSITE', 'ccave')}}</a>
            </XyzTransitionGroup>
        </div>
        <!-- ./card list -->
    </section>
</template>


<script>
    export default {
        name: 'PartnerCards',
        data() {
            return {
                partners: false
            }
        },
        mounted() {
            this.getPartners()
        },
        computed: {
            computedClass() {
                let className = '';
                if ( this.blockData.background_color === 'white' ) {
                    className = [
                        'bg-white',
                    ]
                }
                if ( this.blockData.background_color === 'light-blue' ) {
                    className = [
                        'bg-light-blue-03',
                    ]
                }
                if ( this.blockData.background_color === 'dark-blue' ) {
                    className = [
                        'bg-navy-blue-01',
                    ]
                }
                return className;
            }
        },
        methods: {
            getPartners() {
                this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/partner?partner_type=' + this.blockData.type )
                    .then( res => {
                        this.partners = res.data
                    }
                );
            },
            goToLocation(card) {
                window.location.href = card.cta.url;
            },
            openBlank: function (link) {
                window.open(link, "_blank");
            }
        },
    }
</script>
